module.exports = __webpack_public_path__ + "static/media/ZoomBox.05176c3c.svg";